module.exports = __webpack_public_path__ + "static/img/post6.0aaf04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/post6.png
// module id = OGgq
// module chunks = 0